import React from "react";
import {
  selectActiveBatPrice,
  selectRenderCardArray,
  setRenderCardArray,
} from "../../../redux/3d_game_Slice/panelSlice";
import { useDispatch, useSelector } from "react-redux";

const ShowHereAllNumber = () => {
  const dispatch = useDispatch();

  const renderCardArry = useSelector(selectRenderCardArray);
  const activeBatPrice = useSelector(selectActiveBatPrice);

  const removeCard = (index) => {
    const copyCardArray = [...renderCardArry];
    copyCardArray.splice(index, 1);
    dispatch(setRenderCardArray(copyCardArray));
  };

  return (
    <div className="number-card-container">
      {renderCardArry.map((card, index) => (
        <div className="number-card" key={index}>
          <h6>{card.number}</h6>
          <h6>{card.betType}</h6>
          <h6>{activeBatPrice}</h6>

          <span
            className="remove-btn"
            onClick={() => removeCard(index)}
          >
            ✖
          </span>
        </div>
      ))}
    </div>
  );
};

export default ShowHereAllNumber;